import React from 'react';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-main">
          <div>
            <span className="footer-brand">cálcio em contexto</span>
            <p>Ferramenta educativa para cálculo de estimativa de cálcio ajustado e compreensão das limitações clínicas associadas à fórmula tradicional baseada em albumina.</p>
          </div>
          <div className="footer-links">
            <h2>Outras Fórmulas Clínicas</h2>
            <ul>
              <li><a href="https://superficiecorporal.com.br/">Superfície Corporal</a></li>
              <li><a href="https://osmolaridade.com.br/">Osmolaridade Sérica</a></li>
              <li><a href="https://aniongap.com.br/">Ânion Gap</a></li>
              <li><a href="https://clearancecreatinina.com.br/">Clearance de Creatinina</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-disclaimer">
          <p>Aviso: As informações e cálculos fornecidos neste site são exclusivamente para fins educacionais e não substituem o julgamento clínico. Não utilize estas informações para diagnóstico ou tratamento sem consultar um profissional de saúde qualificado.</p>
          <p>©{new Date().getFullYear()} calciocorrigido.com.br. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
}
